import { useState, useEffect } from "react";
import styled from "styled-components";
import BookService from "../../services/BookService";
import BookDetail from "./BookDetail";
import { Overlay, ModalCloseButton } from "../CommonComponents/DataCard";
import placeholderImage from "../../assets/logo.png";

const MiniCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 110px;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.card};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  transition: transform 0.15s, box-shadow 0.15s;
  &:hover {
    transform: translateY(-3px);
    box-shadow: ${({ theme }) => theme.shadows.md};
  }
`;

const Thumb = styled.img`
  width: 110px;
  height: 155px;
  object-fit: cover;
  display: block;
`;

const Info = styled.div`
  padding: 0.4rem 0.5rem 0.5rem;
`;

const BookTitle = styled.p`
  margin: 0 0 0.2rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
`;

const Authors = styled.p`
  margin: 0;
  font-size: 0.72rem;
  color: ${({ theme }) => theme.colors.lineColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

function BookCardMini({ book, user }) {
  const [thumb, setThumb] = useState(placeholderImage);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    BookService.getBookThumbnail(book.id)
      .then(url => { if (url) setThumb(url); })
      .catch(() => {});
  }, [book.id]);

  const authorNames = book.authors?.map(a => `${a.name} ${a.surname}`).join(", ") || "";

  return (
    <>
      <MiniCard onClick={() => setOpen(true)} title={book.name}>
        <Thumb src={thumb} alt={book.name} />
        <Info>
          <BookTitle>{book.name}</BookTitle>
          {authorNames && <Authors>{authorNames}</Authors>}
        </Info>
      </MiniCard>

      {open && (
        <Overlay
          onClick={() => setOpen(false)}
          style={{ alignItems: "flex-start", padding: "2rem 1rem", overflowY: "auto", boxSizing: "border-box" }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ position: "relative", width: "fit-content" }}
          >
            <ModalCloseButton
              onClick={() => setOpen(false)}
              title="Zatvori"
              style={{ position: "absolute", top: "0.75rem", right: "0.75rem", zIndex: 1 }}
            >×</ModalCloseButton>
            <BookDetail bookId={book.id} user={user} />
          </div>
        </Overlay>
      )}
    </>
  );
}

export default BookCardMini;
